













import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class VimeoVideoModal extends Vue {
    @Prop()
    protected videoUrl!: string;

    constructor() {
        super();
    }

    get formatedVideoUrl() {
        return `${this.videoUrl}&badge=0&autopause=0&autoplay=1&player_id=0&app_id=58479`;
    }

    created() {}

    private close() {
        this.$emit('close');
    }
}
